import { useContext } from 'react'
import { USER_CONTEXT } from '../context/ContextProvider'

const useFormValidate = () => {
  let { setData } = useContext(USER_CONTEXT)
  let validate = (form, group, category, description) => {
    if (
      form.current.title.value != '' &&
      form.current.tagline.value != '' &&
      form.current.tags.value != '' &&
      group != (null || undefined || '') &&
      (category != null || undefined || '') &&
      description != (null || undefined || '')
    ) {
      return true
    } else {
      let id = new Date().getTime()
      setData({
        type: 'SHOW_NOTIFICATION',
        payload: {
          id,
          text: 'Enter form fields correcly!',
          type: 'error',
        },
      })
      setTimeout(() => {
        setData({
          type: 'HIDE_NOTIFICATION',
          payload: {
            id,
          },
        })
      }, 2000)
      return false
    }
  }
  return validate
}

export default useFormValidate
